"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const immutable_1 = require("immutable");
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const transaction_list_1 = require("companion-app-components/flux/transaction-list");
const QButton_1 = __importDefault(require("components/QButton"));
const SearchBox_1 = __importDefault(require("components/SearchBox"));
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const TransactionSelectList_1 = __importDefault(require("components/TransactionSelectList"));
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const SelectTransactionDialog = (_a) => {
    var _b;
    var { onClose, selectorProps, title, buttonText, disableAdd, subtitle, onTransactionSelected, open, transactionListSelector, filterByType, multiSelect } = _a, otherProps = __rest(_a, ["onClose", "selectorProps", "title", "buttonText", "disableAdd", "subtitle", "onTransactionSelected", "open", "transactionListSelector", "filterByType", "multiSelect"]);
    const [selectedTxn, setSelectedTxn] = (0, react_1.useState)(multiSelect ? (0, immutable_1.List)() : null);
    const [processing, setProcessing] = (0, react_1.useState)(false);
    const [search, setSearch] = (0, react_1.useState)(null);
    const autoTimeout = (0, react_1.useRef)(null);
    const { classes } = useStyle();
    (0, react_use_1.useUnmount)(() => {
        if (autoTimeout.current) {
            clearTimeout(autoTimeout.current);
        }
    });
    // This is the function by which a transaction selected from the virtualList in ScheduleList component is stored in
    // this component's state. Couldn't think of a cleaner way to back-pass updates to state. The nested ID checks are
    // used to grab parent ID values, as each transaction row has many child components, but the ID we need is in the
    // parent row.
    const selectTxnFunc = (event) => {
        const selectTxn = JSON.parse(event.currentTarget.id);
        let currentTxn = selectedTxn;
        if (multiSelect) {
            // @ts-expect-error: Type 'never[]' is missing the following properties from type 'CashFlowTransaction'
            currentTxn = currentTxn || [];
            if ((currentTxn === null || currentTxn === void 0 ? void 0 : currentTxn.size) > 0 && (currentTxn === null || currentTxn === void 0 ? void 0 : currentTxn.find((t) => t.id === selectTxn.id))) {
                setSelectedTxn(currentTxn.filter((t) => t.id !== selectTxn.id));
            }
            else {
                // @ts-expect-error: Type 'CashFlowTransaction | List<CashFlowTransaction> | null' must have a '[Symbol.iterator]()' method that returns an iterator.
                setSelectedTxn((0, immutable_1.List)([...currentTxn, selectTxn]));
            }
            return;
        }
        // @ts-expect-error: Property 'id' does not exist on type 'List<CashFlowTransaction>
        if (currentTxn && (currentTxn.id === selectTxn.id)) {
            setSelectedTxn(null);
        }
        else {
            setSelectedTxn(selectTxn);
        }
    };
    const handleComplete = () => {
        if (onTransactionSelected) {
            onTransactionSelected(selectedTxn);
        }
        setProcessing(true);
        autoTimeout.current = setTimeout(() => setProcessing(false), 5000);
    };
    const onCloseFunc = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setSearch(null);
        setSelectedTxn(null);
        setProcessing(false);
    };
    const derivedSelector = transactionListSelector || transaction_list_1.transactionListSelectors.getLesserBilledTransactions;
    return (<StdDialog_1.default title={title || 'Select Transaction'} open={Boolean(open)} fullWidth maxWidth="md" className={classes.dialogRoot} onClose={onCloseFunc} sharedcomponentid={'SELECT_TRANSACTION_DIALOG'} {...otherProps}>
      <div className={classes.headerSection}>
        <Typography_1.default className={classes.subtitle}>
          {subtitle || 'Select or search for a transaction'}
        </Typography_1.default>

        <SearchBox_1.default onSearch={(searchParam) => {
            setSearch(searchParam);
        }} autoSearch autoFocus collapsable={false} initialValue={search !== null && search !== void 0 ? search : undefined} placeholder="Search Transactions" classes={{
            root: classes.searchBar,
            input: classes.searchInput,
        }}/>
      </div>
      <DialogContent_1.default className={classes.greyGrid}>
        <TransactionSelectList_1.default clickFunc={selectTxnFunc} 
    // @ts-expect-error:  Property 'id' does not exist on type 'List<CashFlowTransaction>'.
    highlight={((_b = selectedTxn === null || selectedTxn === void 0 ? void 0 : selectedTxn.map) === null || _b === void 0 ? void 0 : _b.call(selectedTxn, (t) => t.id)) || (selectedTxn === null || selectedTxn === void 0 ? void 0 : selectedTxn.id)} filter={search} onReset={() => setSearch(null)} transactionListSelector={derivedSelector} selectorProps={selectorProps} filterByType={filterByType} multiSelect={multiSelect}/>

        {processing &&
            <div className={classes.processing}>
            <CircularProgress_1.default size={64} className={classes.spinner}/>
          </div>}
      </DialogContent_1.default>

      <div className={classes.buttonBottoms}>
        <QButton_1.default type="submit" id="create-transaction" variant="contained" disabled={!selectedTxn || processing} onClick={handleComplete} style={{ marginRight: 10 }}>
          {buttonText || 'CREATE'}
        </QButton_1.default>

        {!disableAdd &&
            <Typography_1.default variant="body2" className={classes.manualLine}>
            {"Couldn't Find?"}
            <Button_1.default className={classes.manualButton} id="add-manually-transaction" onClick={() => onTransactionSelected && onTransactionSelected()}>
              ADD MANUALLY
            </Button_1.default>
          </Typography_1.default>}
      </div>
    </StdDialog_1.default>);
};
exports.default = SelectTransactionDialog;
